<template>
    <div class="borrow">
        <div class="search">
            <Input v-model="search" :placeholder="$t('searchTips')+'...'" style="width:200px;"></Input>
            <Button type="primary" @click="loadData(currentPage)">搜索</Button>
        </div>
        <Table border :columns="columns12" :data="data6">
            <template slot-scope="{ row }" slot="name">
                <strong>{{ row.name }}</strong>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <div class="op_btn">
                    <Button
                        type="info"
                        size="small"
                        style="margin-right: 5px"
                        @click="showUserDetail(row.user_id)"
                    >{{$t('userInfo')}}</Button>

                       <Button
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        v-if="row.status_id ==2"
                        @click="edit_status(row.order_id,10)"
                    >{{$t('borrow.agreement')}}{{$t('borrow.borrow')}}</Button>
                   <Button
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        v-if="row.status_id ==2"
                        @click="edit_status(row.order_id,11)"
                    >{{$t('borrow.reject')}}{{$t('borrow.borrow')}}</Button>


                      <Button
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        v-if="row.status_id ==100"
                        @click="edit_status(row.order_id,101)"
                    >{{$t('borrow.withdraw_agreement')}}</Button>
                   <Button
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        v-if="row.status_id ==100"
                        @click="withdrawRejectShow(row)"
                    >{{$t('borrow.withdraw_reject')}}</Button>
                    <Button
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        v-if="row.status_id ==102"
                        @click="withdrawEnabledShow(row)"
                    >{{$t('borrow.withdraw_enabled')}}</Button>
<!--                     <Button
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="modalItem=row;$router.push({name:'create_dk_img',query:{order_id:row.order_id,type:1}})"
                    >{{$t('borrow.createRemitImg')}}</Button> -->
                </div>
                <div class="op_btn">
<!--                     <Button
                        type="primary"
                        size="small"
                        style="margin-right: 5px"
                        @click="modalItem=row;$router.push({name:'create_dk_img',query:{order_id:row.order_id,type:2}})"
                    >{{$t('borrow.createInsuranceImg')}}</Button> -->
                    <Button
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="contract(row)"
                    >{{$t('borrow.borrowContract')}}</Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="editMoney(row)">修改额度</Button>
                </div>
                <div class="op_btn">
                    <Button
                        type="warning"
                        size="small"
                        style="margin-right: 5px"
                        @click="change_status(row)"
                        v-if="row.status_id>2"
                    >{{$t('edit')}}{{$t('status')}}</Button>
                    <Button
                        type="success"
                        size="small"
                        style="margin-right: 5px"
                        @click="change_bank(row)"
                    >{{$t('edit')}}{{$t('userView.bankNumber')}}
                        <span v-if="row.bank_num == row.bank_num_init">({{$t('editNo')}})</span>
                        <span class="red_color" v-else>({{$t('edited')}})</span>
                    </Button>
                   <!--  <Button type="error" size="small" @click="delModal(row)">{{$t('del')}}</Button> -->
                </div>
            </template>
        </Table>
        <div class="page">
            <Page
                :total="totalItems"
                :page-size="itemsPerPage"
                show-elevator
                :current="currentPage"
                @on-change="loadData"
            />
        </div>
        <Modal v-model="edit_money" :title="$t('borrow.editLimit')" @on-ok="edit_money_ok">
            <Form :model="modalItem" :label-width="100">
                <FormItem :label="$t('borrow.orderNumber')">
                    <Input v-model="modalItem.order_num" disabled></Input>
                </FormItem>
                <FormItem :label="$t('borrow.borrowMoney')">
                    <Input v-model="modalItem.money"></Input>
                </FormItem>
                <FormItem :label="$t('borrow.borrowTime')">
                    <Input v-model="modalItem.month"></Input>
                </FormItem>
            </Form>
        </Modal>
        <Modal v-model="edit_money2" :title="$t('borrow.editMoney')" @on-ok="edit_money_ok2">
            <Form :model="modalItem" :label-width="100">
                <FormItem :label="$t('borrow.borrowMoney')">
                    <Input v-model="modalItem.wallet"></Input>
                </FormItem>
            </Form>
        </Modal>
         <Modal v-model="withdrawEnabled" :title="$t('borrow.withdraw_enabled')" @on-ok="withdrawEnabledClick">
            <Form :model="modalItem" :label-width="100">
                <FormItem :label="$t('borrow.wallet')">
                    <Input v-model="modalItem.wallet"></Input>
                </FormItem>
            </Form>
        </Modal> 
        <Modal v-model="withdrawReject" :title="$t('borrow.reject')+$t('borrow.withdraw')" @on-ok="withdrawRejectOk">
        <Form :label-width="80" >
                 <Form-item label="订单号">
                         <Input v-model="modalItem.order_num" disabled border="false"  placeholder="" />
                </Form-item>
                <input type ="hidden" :value="modalItem.order_id">
                <Form-item label="状态">
                        <Select  v-model="modalItem.status_id"  style="width:200px" @on-change="withdrawStatusChange">
                            <Option v-for="item in status_data" :value="item.status" :key="item.value">{{ item.status }}</Option>
                        </Select>
                </Form-item>
                 <Form-item label="拒绝原因">
                         <Input v-model="modalItem.custom_content"  placeholder="拒绝原因" />
                </Form-item>
            </Form>
        </Modal>   
        <Modal v-model="jt_img" :title="$t('borrow.insuranceImg')">
            <div class="jt_img">
                <img :src="$ht_ip+''" alt />
            </div>
        </Modal>
        <Modal v-model="change_sts" :title="$t('edit')+$t('status')" @on-ok="edit_status_ok">
            <div class="order_num">
                <div class="tit">订单号</div>
                <div class="info">{{modalItem.order_num}}</div>
            </div>
            <div class="sts_list">
                <div class="tit">状态</div>
                <div class="list">
                    <RadioGroup v-model="modalItem.status_id">
                        <div class="radio_div" v-for="item of status_data">
                            <Radio :label="item.status_id">{{item.status}}</Radio>
                        </div>
                    </RadioGroup>
                </div>
            </div>
        </Modal>

        <Modal
            v-model="showDelModal"
            :title="$t('confirmDel')"
            @on-ok="delRow(modalItem)"
            @on-cancel="showDelModal=false"
        >
            <p>{{$t('confirmDel')}}</p>
        </Modal>
        <Modal
            v-model="showBankNumModal"
            :title="$t('edit')+$t('userView.bankNumberInfo')"
            @on-ok="postBankNum"
            @on-cancel="showBankNumModal=false"
        >
            <div class="tit">{{$t('userView.bankName')}}</div>
            <Input v-model="modalItem.open_bank"></Input>
            <div class="tit" style="margin-top:10px">{{$t('userView.bankNumber')}}({{ modalItem.bank_num_init +')'}}</div>
            <Input v-model="modalItem.bank_num"></Input>
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            modalItem: {},
            showDelModal: false,
            userIdToDel: 0,
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            totalItems: 0,
            search: "",
            totalItems: 1,
            edit_money: false,
            edit_money2: false,
            change_sts: false,
            withdrawEnabled:false,
            withdrawReject:false,
            showBankNumModal: false,
            jt_img: false,
            money_modal: {},
            status_data: [],
            columns12: [
                {
                    title: "ID",
                    width: 60,
                    key: "order_id",
                },
                {
                    title: this.$i18n.t('mobile'),
                    width: 110,
                    key: "mobile",
                },
                {
                    title: this.$i18n.t('userView.cname'),
                    width: 80,
                    key: "name"
                },
                {
                    title: this.$i18n.t('borrow.orderNumber'),
                    width: 130,
                    key: "order_num"
                },
                {
                    title: this.$i18n.t('borrow.borrowTime'),
                    width: 100,
                    key: "month"
                },
                {
                    title: this.$i18n.t('borrow.borrowTotal'),
                    width: 110,
                    key: "money"
                },
                {
                    title: this.$i18n.t('borrow.monthRepayment'),
                    width: 100,
                    key: "month_money"
                },
                {
                    title: this.$i18n.t('time'),
                    width: 100,
                    key: "created_at"
                },
                {
                    title: this.$i18n.t('status'),
                    width: 110,
                    key: "status"
                },
                {
                    title: this.$i18n.t('borrow.cause'),
                    width: 110,
                    key: "custom_content"
                },
                {
                    title: this.$i18n.t('borrow.wallet'),
                    width: 100,
                    key: "wallet",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "div",
                                {
                                    style: {
                                        textAlign: "center",
                                        width: "64px"
                                    }
                                },
                                params.row.wallet
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            this.edit_money2 = true;
                                            this.modalItem = params.row;
                                        }
                                    }
                                },
                                this.$i18n.t('borrow.editMoney')
                            )
                        ]);
                    }
                },
                 {
                    title:this.$i18n.t('borrow.withdraw_num'),
                    key:"withdraw_num",
                    width:100
                },
                {
                    title:this.$i18n.t('agent.agent'),
                    key:"agent_name",
                    width:110
                },
                {
                    title: this.$i18n.t('action'),
                    slot: "action",
                    width: 200,
                    align: "center",
                    fixed:"right"
                }
            ],
            data6: []
        };
    },
    mounted() {
        this.loadData(1);
    },
    methods: {
        loadData(page) {
            this.currentPage = page;
            this.$get(this.$path.borrow, {
                page: this.currentPage,
                search: this.search
            }).then(res => {
                if (res.data) {
                    this.data6 = res.data.list;
                    this.totalItems = res.data.pageObj.totalSize;
                    this.itemsPerPage = res.data.pageObj.pageSize;
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        showUserDetail(user_id) {
            this.$router.push({
                name: "user_detail",
                query: {
                    user_id: user_id
                }
            });
        },
        editMoney(row) {
            this.modalItem = row;
            this.edit_money = true;
        },
        edit_money_ok() {
            this.$post(this.$path.borrow_edit_money, {
                order_id: this.modalItem.order_id,
                money: this.modalItem.money,
                month:this.modalItem.month
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delRow(row) {
            this.$post(this.$path.borrow_del, {
                order_id: this.modalItem.order_id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        delModal(row) {
            this.modalItem = row;
            this.showDelModal = true;
        },
        change_status(row) {
            this.modalItem = row;
            this.change_sts = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
        change_bank(row) {
            this.modalItem = row;
            this.showBankNumModal = true;
        },
        postBankNum() {
            this.$post(this.$path.user_edit, {
                user_id: this.modalItem.user_id,
                banK_num: this.modalItem.bank_num,
                open_bank: this.modalItem.open_bank
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.showBankNumModal = false;
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
                this.loadData(this.currentPage);
            });
        },
        edit_status_ok() {
            this.$post(this.$path.change_status, {
                order_id: this.modalItem.order_id,
                status_id: this.modalItem.status_id
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        edit_status(orderId,status) {
            this.$post(this.$path.change_status, {
                order_id: orderId,
                status_id: status
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        edit_money_ok2() {
            this.$post(this.$path.edit, {
                user_id: this.modalItem.order_id,
                money: this.modalItem.wallet
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        withdrawRejectShow(row) {
            this.modalItem = row;
            this.withdrawReject = true;
            this.$get(this.$path.change_status).then(res => {
                if (res.success) {
                    this.status_data = res.data;
                }
            });
        },
        withdrawRejectOk(){

            this.$post(this.$path.widthdraw_reject, {
                order_id: this.modalItem.order_id,
                custom_content: this.modalItem.custom_content
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        withdrawEnabledShow(row) {
            this.modalItem = row;
            this.withdrawEnabled = true;
        },
        withdrawEnabledClick() {
            this.$post(this.$path.widthdraw_enabled, {
                user_id: this.modalItem.user_id,
                money: this.modalItem.wallet
            }).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                    this.loadData(this.currentPage);
                }
            });
        },
        withdrawStatusChange(data){
            this.modalItem.custom_content = data;
              console.log(data);  
        },
        contract(row){
            this.modalItem=row;
            this.$router.push({name:'contract',query:{
                user_id:this.modalItem.user_id
            }})
        }
    }
};
</script>
<style lang="scss" scoped>
.search {
    margin-bottom: 20px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.jt_img {
    width: 100%;
    img {
        width: 100%;
    }
}
.order_num {
    display: flex;
    flex-direction: row;
    .tit {
        width: 60px;
        color: #bab9b9;
    }
    .info {
        width: 200px;
    }
}
.sts_list {
    margin-top: 10px;
    .tit {
        width: 100px;
        color: #bab9b9;
    }
}
.op_btn {
    margin-top: 5px;
}
.op_btn:nth-child(2) {
    margin-bottom: 5px;
}
/*.radio_div {
     width: 25%; 
}*/
.ivu-radio-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}
.red_color{
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/borrow/borrow.vue